import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Explore_Btn.css";
import {
    faAngleRight,
    faArrowRight,
    faArrowRightLong,
    faPlay,
} from "@fortawesome/free-solid-svg-icons";

const Explore_Btn = ({ btnText, type, onClick}) => {
    return (
        <button
            className="Explore_Btn"
            type={type ? type : "button"}
            onClick={onClick}
        >
            <p className="btn_text">{btnText}</p>
            <div className="arrow_div">
                <FontAwesomeIcon icon={faArrowRightLong} className="arrow_text" />
            </div>
        </button>
    );
};

export default Explore_Btn;
